import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';

// Bootstrap component
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { processResponse, processItemResponse } from '../../../../../utilities/processResponse'

import MultiSelectedImageCaptcha from './MultiSelectedImageCaptcha';



class MultiSelectImageResponse extends Component {
	constructor(props) {
		super(props);

		this.state = {
			active: 0,
			isSelect: false,
			responseValue: "",
			acceptComment: null,
			tempVal: "",
			images: [],
			selectAllChecked: false,
			isCheckmark:false
		};


		this.isUpdateResponse = false;
		this.reviewPage = this.props.questionItemList || [];
		this.itemCollection = [];
		this.images = [];
	}


	componentWillReceiveProps(nextProps) {
		if (this.isGetAllUpdate !== true) {

			const {
				items,
				singleSelectImageItemConfiguration,
				getAllItemResponseForMultiple,
				rateeKey,
				putAllForItemCollection
			} = nextProps;

			for (const key in getAllItemResponseForMultiple) {
				this.isUpdateResponse = true;

				if (Object.hasOwnProperty.call(getAllItemResponseForMultiple, key)) {
					const elementRes = getAllItemResponseForMultiple[key];

					if (rateeKey !== undefined && key === rateeKey) {
						const { itemResponseSets } = elementRes;
						for (const key in itemResponseSets) {
							this.isGetAllUpdate = true;

							if (itemResponseSets.hasOwnProperty(key)) {
								const element = itemResponseSets[key];
								const tempItemResponseSets = itemResponseSets[key];

								if (element.itemKey.toLowerCase() === items.key.toLowerCase()) {
									var itemResponsesObj =
										element.itemResponses.length > 0
											? element.itemResponses
											: element.demographicResponses.length > 0
											? element.demographicResponses
											: [];
									this.reviewPage[items.key][0].userResponse = itemResponsesObj;

									itemResponsesObj.forEach((item) => {
										if (
											item.response !== null &&
											this.state.isSelect === false
										) {
											this.setState({
												isSelect: true,
												responseValue: item.response,
												// acceptComment:item.openEnd
											});
											var count = this.reviewPage[items.key][0].userResponse.length || 0;
											this.state.images.filter((items) => {
												if (
													items.response === item.response &&
													item.responseValue === 1
												) {
													items.isSelected = true;
													this.setState({isCheckmark:true})
												}
											});
										}
									});
									if (tempItemResponseSets.itemResponses.length > 0) {
										for (const key in tempItemResponseSets.itemResponses) {
											if (
												tempItemResponseSets.itemResponses.hasOwnProperty(key)
											) {
												const temp = tempItemResponseSets.itemResponses[key];
												const itemList = this.reviewPage[items.reviewPageKey];

												for (const key in itemList) {
													if (itemList.hasOwnProperty(key)) {
														const itemRes = itemList[key];
														var itemResponseArr = tempItemResponseSets.itemResponses.length > 0
															? tempItemResponseSets.itemResponses
															: tempItemResponseSets.demographicResponses
																.length > 0
																? tempItemResponseSets.demographicResponses
																: [];
														this.sequenceCount = itemResponseArr.length + 1;

														if (
															temp.response !== null &&
															this.state.isSelect === false
														) {

															itemRes.isAnswer =
																temp.responseValue !== null ? true : false;
															itemRes.isRequired = itemRes.requiredIndicator == 2 ? false :true;
															itemRes.itemResponses[
																tempItemResponseSets.itemKey
															] = itemResponseArr;

															var itemType =
																singleSelectImageItemConfiguration.itemType;
															var responseSet = this.props.itemResponses[
																tempItemResponseSets.itemKey
															] = {};
															processItemResponse(
																tempItemResponseSets.itemKey,
																responseSet,
																tempItemResponseSets.itemResponses,
																itemType,
																rateeKey,
																putAllForItemCollection,
																"onLoad"
															);
														}
													}
												}
											}
										}
									} else {
										if (items.requiredIndicator == 2) {
                                            items.isRequired = true;
                                        } else {
                                            items.isRequired = false;
                                        }
									}
								}
							}
						}
					}
				}
			}
		}
	}

	async componentDidMount() {
		const { configuration, items, activePageKey } = this.props;
		var defaultImg = "https://www.gemkom.com.tr/wp-content/uploads/2020/02/NO_IMG_600x600-1.png";
		await configuration !== undefined &&
			configuration.map((item) => {
				
				item.src = item.responseImageUrl !== "" ? item.responseImageUrl : defaultImg;
				item.thumbnail = item.responseImageUrl !== "" ? item.responseImageUrl : defaultImg;
				//item.thumbnailWidth = 400;
				//item.thumbnailHeight = 300;
				item.isSelected = false;
				item.thumbnailCaption = (
					<span
						className="title"
						dangerouslySetInnerHTML={{ __html: item.responseDescription }}
					></span>
				);
			});
		this.images = configuration;
		this.setState({ images: configuration });
		// this.handleSkipPage(responseValue);
	}


	handleChange = async(event, configuration, rateeKey, index, type) => {
		try {
			const {
				items,
				handleItemResponse,
				singleSelectImageItemConfiguration,
				itemProperties,
				itemTempResponses,
				ratees,
				putAllForItemCollection,
			} = this.props;
			const { responseDescription, response } = this.state.images[index];
			const { minSelections, maxSelections } = itemProperties.itemTypeProperties;

            var acceptComment = type === "input" ? event.target.value : null;
            var tempMinSelections = parseInt(minSelections) || 0;
            var tempMaxSelections = parseInt(maxSelections) || 0;

            var isMinSelection = itemProperties.itemTypeProperties.hasOwnProperty("minSelections");
            var isMaxSelection = itemProperties.itemTypeProperties.hasOwnProperty("maxSelections");

			this.setState({
				active: configuration.responseValue,
				isSelect: true,
				responseValue: configuration.responseValue,
				acceptComment: acceptComment,
			});
			var checkedCount = 0;
			var nodeList = this.images;


			/* Manage the question answer response */
			for (const key in this.reviewPage[items.reviewPageKey]) {
				if (this.reviewPage.hasOwnProperty(items.reviewPageKey)) {
					const itemList = this.reviewPage[items.reviewPageKey];
					var itemKey = itemList[key].key;

					if (itemList[key].key.toLowerCase() === items.key.toLowerCase()) {
						for (const rKey in ratees) {
							if (isMinSelection || isMaxSelection) {

								for (const i in nodeList) {
									if (nodeList.hasOwnProperty(i)) {
										const element = nodeList[i];

										if (element.isSelected) {
											checkedCount = checkedCount + 1;
										}

										if (checkedCount >= tempMinSelections && tempMaxSelections < checkedCount) {
											nodeList[index].isSelected = false;
											itemList[key].isAnswer = true;
											itemList[key].isRequired = false;

											return false;
										} else {
											const selectCount = itemList[key].userResponse.length - 1 || 0;
                                            itemList[key].isAnswer = selectCount !== 0 ? true : false;
										}

										if (isMinSelection) {
											itemList[key].isAnswer = (checkedCount >= tempMinSelections) || (tempMaxSelections <= checkedCount) ? true : false;;
											itemList[key].isRequired = (checkedCount >= tempMinSelections) || (tempMaxSelections <= checkedCount) ? false : true;
										}

									}
								}
							} else if (nodeList[index].isSelected) {
								checkedCount = checkedCount + 1;
								itemList[key].isAnswer = true;
								itemList[key].isRequired = itemList[key].requiredIndicator == 2 ? false :true;
								this.isChecked = true;

							} else {
								const selectCount = itemList[key].userResponse.length - 1 || 0;
								itemList[key].isRequired = selectCount !== 0 ? false : true;
								this.isChecked = true;
							}

							var count = nodeList.length;
							var value = 0;
							for (const key in nodeList) {
								if (Object.hasOwnProperty.call(nodeList, key)) {
									const element = nodeList[key];
									if (element.isSelected) {
										value = element.value
										count--;
									}
								}
							}
							if (count !== nodeList.length) {
								// this.handleSkipPage(Number(value));
							} else {
								// this.handleSkipPage(Number(0));
								itemList[key].isAnswer = false;
								itemList[key].isRequired = itemList[key].requiredIndicator == 2 ? true :false;
							}

							if (ratees.hasOwnProperty(rKey)) {
								const tempRatees = ratees[rKey];

								if (tempRatees.dataCollectionGuid === rateeKey) {
									var resValue = this.state.images[index].isSelected ? 1 : null;
									var getCount = this.state.images.filter((item) => item.isSelected);

									itemList[key].isAnswer = getCount.length >= tempMinSelections ? true : false;

									if (itemList[key].requiredIndicator == 2) {
										itemList[key].isRequired = itemList[key].isAnswer == true ? false :true;
									} else {
										itemList[key].isRequired = false;
									}

									itemList[key].itemResponses[itemKey] = [{
										itemType: singleSelectImageItemConfiguration.itemType,
										buttonGroup: null,
										sequence: 1,
										isNa: itemList[key].isNA,
										response: response,
										responseValue: resValue,
										openEnd: acceptComment,
										responseDescription: responseDescription,
									}];

									if (this.state.images[index].isSelected === true) {
										var data = itemList[key].itemResponses[itemKey][0];

										if (type !== "input") {
												itemList[key].userResponse.push(data);
										} else {
											itemList[key].userResponse.filter((item) => {
												if (item.response === configuration.response) {
													item.responseValue = null;
												}
												return true;
											});
										}
									} else {
										itemList[key].userResponse.filter((item) => {

											if (item.response === configuration.response) {
													itemList[key].userResponse.splice(itemList[key].userResponse.indexOf(item), 1);
													delete itemList[key].itemResponses[itemKey];
											}
											return true;
										});
									}

									var responseSet = (this.props.itemTempResponses[itemKey] =
										{});
									var itemResponses = itemList[key].userResponse;
									var itemType = singleSelectImageItemConfiguration.itemType;

									itemResponses.filter((item, i) => {
										if (item.response == response) {
											item.responseValue = resValue;
										}
									});

									processItemResponse(
										itemKey,
										responseSet,
										itemResponses,
										itemType,
										rateeKey,
										putAllForItemCollection,
										"onChange"
									);
								}
							}
						}
					} else {
						if (itemList[key].isAnswer !== true) itemList[key].isAnswer = false;
					}
				}
			}

			handleItemResponse(items.key, itemTempResponses, "itemChange", rateeKey);
		} catch (error) {
			console.log(
				"Exception: while responding question answer in multi select response:_",
				error
			);
		}
	};



render() {
		const { configuration, activePageKey, itemKey } = this.props;

		return (
			<Fragment>
				<Row>
					<Col xs={12} key={itemKey} className={`_LIS_SingleSelect`}>
						{configuration.scalePreSection !== null ? (
							<div
								dangerouslySetInnerHTML={{
									__html: processResponse(configuration.scalePreSection),
								}}
							></div>
						) : null}
						<Col col={10} className={`${activePageKey}`}>
						<MultiSelectedImageCaptcha
				       		image={this.state.images} 
            				handleChange={this.handleChange}
							rateeKey={this.props.rateeKey}
							maxSelections = { this.props.itemProperties.itemTypeProperties.maxSelections }
          				/>
								
						</Col>
						{configuration.scalePreSection !== null ? (
							<div
								dangerouslySetInnerHTML={{
									__html: processResponse(configuration.scalePreSection),
								}}
							></div>
						) : null}
					</Col>
				</Row>
				
			</Fragment>
		);
	}
}

const mapStateToProps = (state) => ({
		answeredQuestionCount: state.survey.answeredQuestionCount,
		getAllItemResponse: state.survey.getAllItemResponse,
		getAllItemResponseForMultiple: state.survey.getAllItemResponseForMultiple
})

export default connect(mapStateToProps)(MultiSelectImageResponse);